import { Permission, PermissionAction } from 'generated/openApi';
import { CardPermissionRequirement } from '../types/DashboardCardConfig';

export const CARD_PERMISSION_MAP: Record<number, CardPermissionRequirement[]> = {
    3: [{ permission: Permission.MatchReport, action: PermissionAction.View }],
    4: [{ permission: Permission.MatchReport, action: PermissionAction.View }],
    6: [{ permission: Permission.StudentEnrollment, action: PermissionAction.View }],
    7: [{ permission: Permission.StudentEnrollment, action: PermissionAction.View }],
    10: [{ permission: Permission.StudentEnrollment, action: PermissionAction.View }],
    11: [{ permission: Permission.StudentEnrollment, action: PermissionAction.View }],
};